var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"button-ctn"},[_c('a',{staticClass:"btn",attrs:{"href":("../" + (_vm.props.pdfFileName)),"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"btn__icon",attrs:{"icon":"file-pdf"}}),_c('span',[_vm._v("Download em PDF")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }